// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'shipments.justificarDialog.reasonLabel': 'Justificativa',
    'shipments.justificarDialog.reasonPlaceholder': 'Descreva o motivo',
    'shipments.justificarDialog.wait': 'Aguarde…',
  },
  en: {
    'shipments.justificarDialog.reasonLabel': 'Justification',
    'shipments.justificarDialog.reasonPlaceholder': 'Describe the reason',
    'shipments.justificarDialog.wait': 'Please wait…',
  },
  es: {
    'shipments.justificarDialog.reasonLabel': 'Justificación',
    'shipments.justificarDialog.reasonPlaceholder': 'Describa el motivo',
    'shipments.justificarDialog.wait': 'Espere…',
  },
}
